import React, {Fragment, useEffect, useState} from "react";
import {Button, Form, Spinner} from "react-bootstrap";
import {useForm} from "react-hook-form";
import {useYupValidationResolver} from "../../../common";
import * as yup from "yup";
import {ErrorMessage} from "../../../parts/error-message";
import {adminUpdateOrg} from "../../../api-service/account";
import {toast} from "react-toastify";

const validationSchema = yup.object({
    HolidaysViewList: yup
        .string()
        .test(
            "is-valid-format",
            "正しい形式で入力してください。",
            (value) => {
                if (!value) return true;
                if (
                    value.startsWith(",") ||
                    value.endsWith(",") ||
                    value.includes(",,")
                ) {
                    return false;
                }
                return true;
            }
        ),
    OrgId: yup.string(),
    IdleHomeTimeoutSeconds: yup.number()
        .transform((value, originalValue) => {
            if (
                originalValue === '' ||
                originalValue === null ||
                Number.isNaN(value)
            ) {
                return undefined;
            }
            return value;
        })
        .integer("正しいタイムアウト秒を入力してください")
        .min(1, "タイムアウト秒の最小の値は1です。")
        .max(10 ** 12 - 1, "最大12桁数を入力してください。")
        .nullable()
        .notRequired()
});

export function TabOrgComponent({
                                    accountInfo,
                                    orgSelected,
                                    onSubmit,
                                }) {
    const [listOrg, setListOrg] = useState([]);
    const resolver = useYupValidationResolver(validationSchema);
    const {
        register,
        control,
        handleSubmit,
        setValue,
        reset,
        getValues,
        watch,
        clearErrors,
        formState: {isSubmitting, isDirty, errors, isSubmitted}
    } = useForm({
        resolver: resolver,
        defaultValues: {
            HolidaysViewList: "",
            OrgId: "",
            IdleHomeTimeoutSeconds: '',
        },
        mode: "onBlur",
        reValidateMode: "onChange"

    });
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        if (accountInfo) {
            setListOrg(accountInfo.listsOrg)
            const selectedOrg = accountInfo.listsOrg.find((item: any) => item.OrgId === orgSelected);
            reset({
                HolidaysViewList: selectedOrg?.HolidaysViewList ?? "",
                OrgId: orgSelected,
                IdleHomeTimeoutSeconds: selectedOrg?.IdleHomeTimeoutSeconds ?? '',
            })
        }
    }, [accountInfo]);
    const submitFormData = async (data) => {
        setLoading(true);
        await adminUpdateOrg(data).then((response: any) => {
            console.log(response);
            toast.success("保存されました。");
            onSubmit();
            setLoading(false);
        }).catch(err => {
            toast.error("保存処理に失敗しました。再度お試しください。");
            setLoading(false);
        });
    }
    const changeOrgs = async (e) => {
        const selectedOrg = listOrg.find((item: any) => item.OrgId === e.target.value);
        console.log(selectedOrg, e)
        reset({
            HolidaysViewList: selectedOrg?.HolidaysViewList ?? "",
            OrgId: selectedOrg?.OrgId,
            IdleHomeTimeoutSeconds: selectedOrg?.IdleHomeTimeoutSeconds ?? '',
        })
    }


    return (
        <Fragment>
            <div className="tab-setting-account bg-white p-3">
                <Form onSubmit={handleSubmit(submitFormData)}>
                    <div className="d-flex pt-3">
                        <Form.Label className="me-2 modal-form-label d-flex align-items-center mb-0">
                            組織ID
                        </Form.Label>
                        <div className="d-flex flex-column w-100">
                            <Form.Select {...register("OrgId")}
                                         value={watch("OrgId")}
                                         onChange={changeOrgs}>
                                {listOrg.map((org) => (
                                    <option key={org.OrgId} value={org.OrgId}>
                                        {org.OrgId}
                                    </option>
                                ))}
                            </Form.Select>
                        </div>
                    </div>
                    <div className="d-flex pt-3">
                        <Form.Label className="me-2 modal-form-label d-flex align-items-center mb-0">
                            表示休暇名
                        </Form.Label>
                        <div className="d-flex flex-column w-100">
                            <Form.Control
                                className="form-control w-100 h-auto fs-13"
                                {...register("HolidaysViewList")}
                                as="textarea" rows={3}
                                isInvalid={isSubmitted && !!errors?.HolidaysViewList}
                            />
                            {isSubmitted &&
                                <ErrorMessage name='HolidaysViewList' className={'mb-0 w-100 fs-13'} errors={errors}/>}
                            <p className="mb-0 w-100 fs-13">
                                ※休暇名をカンマ[ , ]区切りで入力してください
                            </p>
                        </div>

                    </div>
                    <div className="d-flex pt-3">
                        <Form.Label className="me-2 modal-form-label d-flex align-items-center mb-0">
                            タイムアウト秒
                        </Form.Label>
                        <div className="d-flex flex-column w-100">
                            <Form.Control
                                type="number"
                                className="form-control w-100 h-auto fs-13"
                                {...register("IdleHomeTimeoutSeconds", { valueAsNumber: true })}
                                isInvalid={isSubmitted && !!errors?.IdleHomeTimeoutSeconds}
                            />
                            {isSubmitted &&
                                <ErrorMessage name='IdleHomeTimeoutSeconds' className={'mb-0 w-100 fs-13'} errors={errors}/>}
                        </div>
                    </div>


                    <div className="d-flex pt-3 justify-content-center">
                        {
                            isLoading ?
                                <Button size={'sm'} className="button-search" disabled>
                                    <Spinner
                                        as="span"
                                        animation="grow"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    保存...
                                </Button>
                                :
                                <Button className="btn-detail btn btn-primary btn-sm" type={"submit"}>
                                    保存
                                </Button>
                        }

                    </div>

                </Form>
            </div>
        </Fragment>
    )

}